export enum GameDisallowedReason {
  District = 'District',
  ParentOptIn = 'ParentOptIn',
  Grade = 'Grade',
  Homework = 'Homework',
  PlayTime = 'PlayTime'
}
